import { render, staticRenderFns } from "./Beneficiaries.vue?vue&type=template&id=37caa55c&scoped=true"
import script from "./Beneficiaries.vue?vue&type=script&lang=js"
export * from "./Beneficiaries.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "@/assets/styles/multiselect.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=37caa55c&prod&scoped=true&lang=css&external"
import style3 from "./Beneficiaries.vue?vue&type=style&index=3&id=37caa55c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37caa55c",
  null
  
)

export default component.exports